import React, { Component } from "react";
import Table from "../common/Table";
import SearchForm from "./SearchForm";

export default class Accounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      searchConditions: {},
      lastPage: 1,
      currentPage: 1,
      from: "",
      to: "",
      total: "",
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  /**
   * Get search data
   */
  handleSearch(key) {
    this.setState({
      searchConditions: key,
    });
    axios.post("/api/accounts/search", key).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: $.param(key),
      });
    });
  }

  /**
   * Init data and form client or list accounts
   */
  componentWillMount() {
    const keySearch_str = this.props.location.search.substring(1);
    let keySearch_arr = { page: 1 };
    if (keySearch_str) {
      keySearch_arr = JSON.parse(
        '{"' +
          decodeURI(keySearch_str.replace(/&/g, '","').replace(/=/g, '":"')) +
          '"}'
      );
    }

    //always get list data
    axios.post("/api/accounts/search", keySearch_arr).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        searchConditions: keySearch_arr,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: keySearch_str,
      });
    });
  }

  /**
   * Download accounts
   */
  handleDownload() {
    location.href =
      "/accounts/download?" + $.param(this.state.searchConditions);
  }

  /**
   * Sort data
   */
  handleSort(key) {
    //add sort params to search conditions
    let newSearchConditions = this.state.searchConditions;
    newSearchConditions.sort_column = key.sort_column;
    newSearchConditions.sort_type = key.sort_type;
    this.setState({
      searchConditions: newSearchConditions,
    });
    axios.post("/api/accounts/search", newSearchConditions).then((response) => {
      this.setState({
        accounts: response.data.data,
        lastPage: response.data.last_page,
        currentPage: response.data.current_page,
        from: response.data.from,
        to: response.data.to,
        total: response.data.total,
      });
      this.props.history.push({
        search: $.param(newSearchConditions),
      });
    });
  }

  /**
   * Edit account
   * account: Object Account
   */
  handleEdit(account) {
    this.props.history.push("/accounts/edit/" + account.client_id);
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }

  render() {
    const columns = [
      { name: "client_id", title: "依頼者ID", isSort: 1, type: "text" },
      { name: "staff_id", title: "ワーカーID", isSort: 1, type: "text" },
      {
        name: "firstlast",
        title: "名前",
        isSort: 1,
        type: "truncate",
        truncateLength: 10,
        isSearch: true,
      },
      { name: "bill_flag", title: "種別", isSort: 1, type: "text" },
      {
        name: "nickname",
        title: "ニックネーム",
        isSort: 1,
        type: "truncate",
        truncateLength: 10,
        isSearch: true,
      },
      {
        name: "email",
        title: "メールアドレス",
        isSort: 1,
        type: "text_limit",
        isSearch: true,
      },
      {
        name: "tel",
        title: "電話番号",
        isSort: 0,
        type: "text",
        isSearch: true,
      },
      { name: "gender", title: "性別", isSort: 1, type: "gender" },
      {
        name: "birthday",
        title: "年齢",
        isSort: 1,
        type: "age",
        prefix: "",
        suffix: "歳",
      },
      { name: "pref", title: "都道府県", isSort: 1, type: "text" },
      { name: "city", title: "市区", isSort: 1, type: "text" },
      {
        name: "status",
        title: "ステータス",
        isSort: 1,
        type: "option",
        option: {
          1: { text: "承認", classHTML: "text-teal" },
          9: { text: "否認", classHTML: "text-pink" },
          0: { text: "未承認", classHTML: "text-gray" },
          null: { text: "未承認", classHTML: "text-gray" },
          8: { text: "停止", classHTML: "text-warning" },
        },
      },
      { name: "created_at", title: "登録日", isSort: 1, type: "date" },
      {
        name: "job_request_count",
        title: "依頼数",
        isSort: 1,
        type: "text",
        prefix: "",
        suffix: "件",
      },
      { name: "job_apply_count", title: "応募数", isSort: 1, type: "text" },
      {
        name: "staff_evaluation_count",
        title: "ワーカー実績",
        isSort: 1,
        type: "text",
      },
      {
        name: "client_evaluation_avg",
        title: "依頼者評価",
        isSort: 1,
        type: "truncate",
        truncateLength: 4,
      },
      {
        name: "staff_evaluation_avg",
        title: "ワーカー評価",
        isSort: 1,
        type: "truncate",
        truncateLength: 4,
      },
      {
        name: "current_point",
        title: "報酬残高",
        isSort: 1,
        type: "text",
        prefix: "",
        suffix: "円",
      },
      {
        name: "anti_check",
        title: "反社チェック",
        isSort: 1,
        type: "option",
        option: {
          1: { text: "問題あり", classHTML: "text-pink" },
          9: { text: "問題なし", classHTML: "text-teal" },
          0: { text: "未対応", classHTML: "text-gray" },
          null: { text: "未対応", classHTML: "text-gray" },
        },
      },
      {
        name: "reach_from",
        title: "経由",
        isSort: 1,
        type: "option",
        option: {
          1: { text: "Google", classHTML: "text-gray" },
          2: { text: "Yahoo", classHTML: "text-gray" },
          12: { text: "インディード", classHTML: "text-gray" },
          13: { text: "ワーキン", classHTML: "text-gray" },
          15: { text: "engage", classHTML: "text-gray" },
          3: { text: "その他webサイト", classHTML: "text-gray" },
          4: { text: "Twitter", classHTML: "text-gray" },
          5: { text: "Instagram", classHTML: "text-gray" },
          6: { text: "Facebook", classHTML: "text-gray" },
          7: { text: "テレビ", classHTML: "text-gray" },
          8: { text: "新聞記事", classHTML: "text-gray" },
          9: { text: "雑誌", classHTML: "text-gray" },
          14: { text: "チラシ", classHTML: "text-gray" },
          10: { text: "紹介", classHTML: "text-gray" },
          16: { text: "農業Week", classHTML: "text-gray" },
          11: { text: "エントリースタッフ", classHTML: "text-gray" },
          99: { text: "その他", classHTML: "text-gray" },
          null: { text: "未回答", classHTML: "text-gray" },
        },
      },
      // { name: "accessed_at", title: "最終ログイン日", isSort: 1, type: "date" },
    ];
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  登録者一覧
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <main id="main">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h4 className="mt-2 mb-0 page-title">登録者一覧</h4>
                    </div>
                    <div className="col text-right">
                      <a
                        onClick={this.handleRedirect}
                        href="/accounts/imports"
                        className="btn btn-warning btn-space"
                      >
                        CSVインポート
                      </a>
                      <button
                        className="btn btn-light"
                        type="button"
                        data-toggle="collapse"
                        data-target="#search_client"
                        aria-expanded="false"
                        aria-controls="search_client"
                      >
                        絞込検索
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <SearchForm onSearch={this.handleSearch} />
                    </div>
                  </div>
                </div>
                <Table
                  onSearch={this.handleSearch}
                  onEdit={this.handleEdit}
                  header={columns}
                  data={this.state.accounts}
                  onSort={this.handleSort}
                  from={this.state.from}
                  to={this.state.to}
                  total={this.state.total}
                  myPagination={1}
                  optionDownload={1}
                  onDownload={this.handleDownload}
                  searchConditions={this.state.searchConditions}
                  lastPage={this.state.lastPage}
                  currentPage={this.state.currentPage}
                />
              </div>
            </div>
          </div>
        </main>
      </React.Fragment>
    );
  }
}
